import { HttpContextToken, HttpHeaders } from "@angular/common/http";

export const azItems = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
export const emptyGuid = "00000000-0000-0000-0000-000000000000";
export const DISABLE_DEFAULT_TOASTER_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const noResponseToastHeaders = new HttpHeaders().append('X-MY-CLOUD-No-Response-Toast', 'true');
